export const VISIT_REASON_TO_LABEL: Record<string, string> = {
  Video: 'Established',
  'Video-New': 'New Patient',
  'Behavioral Health': 'BH Visit',
  'Health Guide Consult': 'HG Visit',
  'Annual Wellness Visit Established': 'Est. Annual Wellness',
  'Annual Wellness Visit New': 'New Patient Annual Wellness',
}
